import React, { isValidElement, ReactNode, ReactElement } from "react"
import { StyleSheet } from "~/ui/primitives"
import { useTheme } from "~/ui/styled"
import { ColumnFlex, StartFlex, CenterFlex, BetweenFlex, Button, Text, IconFont } from "~components/El"
import RenderSuffix from "./RenderSuffix"
import { SettingGroup, SettingItem } from "../types"

const suffixContentElement = (content?: ReactElement | (() => ReactElement)): ReactNode => {
  const theme = useTheme()
  if (typeof content === 'string' || typeof content === 'number') {
    return <Text style={{ color: theme.colors.text }} fontSize={theme.fontSizes.md} lineHeight="22px">{content}</Text>
  }

  if (isValidElement(content)) {
    return content
  }

  if (typeof content === 'function') {
    try {
      const result = content()
      // ⚡递归调用，保证函数返回值也能被正常处理
      return suffixContentElement(result)
    } catch (err) {
      return null
    }
  }

  return null
}
const SwitchGroup: React.FC<{
  item: SettingGroup
  onClick: (v: SettingItem) => void
  suffixContent?: ReactElement | (() => ReactElement)
}> = ({ item, onClick, suffixContent }) => {
  const theme = useTheme()
  return (
    <ColumnFlex
      height="auto"
      width="100%"
      padding="0 12px"
      mb="10px"
      borderRadius="8px"
      bg={theme.colors.blockBackground}
    >
      {item.title && (
        <ColumnFlex
          width="100%"
          height="auto"
          padding="14px 0"
          borderBottomWidth={StyleSheet.hairlineWidth}
          borderBottomColor={theme.colors.border}
          borderBottomStyle="solid"
        >
          <Text color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600">{item.title}</Text>
          {item.description && (<Text color={theme.colors.secondary} fontSize={theme.fontSizes.sm} mt="3px">{item.description}</Text>)}
        </ColumnFlex>
      )}
      
      <ColumnFlex width="100%" height="auto">
       {item.contents.map((content, idx) => (
        content?.suffix?.type === "switch" ? (
          <ColumnFlex key={idx} width="100%" padding="12px 0">
            <BetweenFlex width="100%">
              <StartFlex>
                {content.icon && (
                  <CenterFlex
                    width="36px"
                    height="36px"
                    style={{
                      flexShrink: 0,
                    }}
                    mr="10px"
                    borderRadius="18px"
                    bg={content.bg}
                  >
                    <IconFont name={content.icon} size={content.iconSize} color={content.iconColor} />
                  </CenterFlex>
                )}
                
                <ColumnFlex>
                  {content.title && (<Text fontSize={theme.fontSizes.md} color={theme.colors.text} fontWeight="600">{content.title}</Text>)}
                  {content.content && (<Text fontSize={theme.fontSizes.sm} color={theme.colors.secondary} mt="2px">{content.content}</Text>)}
                </ColumnFlex>
              </StartFlex>
              <StartFlex width="auto" minWidth={'max-content'}>
                <RenderSuffix suffix={content.suffix} />
              </StartFlex>
            </BetweenFlex>
          </ColumnFlex>
        ) : (
          <Button
            key={idx}
            width="100%"
            padding="12px 0"
            onClick={() => onClick(content)}
          >
            <BetweenFlex width="100%">
              <StartFlex>
                {content.icon && (
                  <CenterFlex
                    width="36px"
                    height="36px"
                    style={{
                      flexShrink: 0,
                    }}
                    mr="10px"
                    borderRadius="18px"
                    bg={content.bg}
                  >
                    <IconFont name={content.icon} size={content.iconSize} color={content.iconColor} />
                  </CenterFlex>
                )}
                
                <ColumnFlex>
                  {content.title && (<Text fontSize={theme.fontSizes.md} color={theme.colors.text} fontWeight="600">{content.title}</Text>)}
                  {content.content && (<Text fontSize={theme.fontSizes.sm} color={theme.colors.secondary} mt="2px">{content.content}</Text>)}
                </ColumnFlex>
              </StartFlex>
              <StartFlex width="auto" minWidth={'max-content'}>
                <RenderSuffix suffix={content.suffix} />
              </StartFlex>
            </BetweenFlex>
          </Button>
        )
       ))}
        
      </ColumnFlex>
       {suffixContentElement(suffixContent)}
    </ColumnFlex>
   
  )
}
export default SwitchGroup
